export var WhatsAppStepsEnum;
(function (WhatsAppStepsEnum) {
    WhatsAppStepsEnum[WhatsAppStepsEnum["LOGIN"] = 0] = "LOGIN";
    WhatsAppStepsEnum[WhatsAppStepsEnum["SELECT_PHONE"] = 1] = "SELECT_PHONE";
    WhatsAppStepsEnum[WhatsAppStepsEnum["AWAIT_CONTAINER"] = 2] = "AWAIT_CONTAINER";
    WhatsAppStepsEnum[WhatsAppStepsEnum["ASK_PIN"] = 3] = "ASK_PIN";
    WhatsAppStepsEnum[WhatsAppStepsEnum["VERIFIED"] = 4] = "VERIFIED";
    WhatsAppStepsEnum[WhatsAppStepsEnum["PHONE_NOT_FOUND"] = 5] = "PHONE_NOT_FOUND";
    WhatsAppStepsEnum[WhatsAppStepsEnum["NOT_POSSIBLE_TO_CONNECT_DUE_NUMBERS_BALANCE"] = 6] = "NOT_POSSIBLE_TO_CONNECT_DUE_NUMBERS_BALANCE";
    WhatsAppStepsEnum[WhatsAppStepsEnum["FACEBOOK_CONNECTION"] = 7] = "FACEBOOK_CONNECTION";
    WhatsAppStepsEnum[WhatsAppStepsEnum["WABA_WITH_ACTIVE_NUMBER_IN_ANOTHER_CONTRACT"] = 8] = "WABA_WITH_ACTIVE_NUMBER_IN_ANOTHER_CONTRACT";
})(WhatsAppStepsEnum || (WhatsAppStepsEnum = {}));
